<template>
  <div class="attendanc-code">
    <div v-if="isEnvironment">
      <div class="enterprise-code">
        <i></i>
        {{ userInfo.entName }}
      </div>
      <div class="attendanc-conter">
        <b>考勤码</b>
        <div class="conter-code">
          <img
            class="login-code"
            src="../../../../assets/imagess/huzhoulogo.png"
            alt=""
          />
          <div id="qrcode" ref="qrcode"></div>
          <img class="qrcode-img" :src="imgSrce" alt="" />
        </div>
        <div class="explain">微信扫一扫二维码，实现快速打卡</div>
      </div>
      <div class="attendac-footer">
        <van-button type="default" class="confirm" @click="downloadImg"
          >保存图片</van-button
        >
      </div>
    </div>
    <div v-else class="attendanc-wx">
      请使用微信扫码
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { Toast } from 'vant'
import { getOpenIdByCode } from '@api/lishui'
import { getLocalStorage, getQueryString, getIsWxClient, wxGrant } from '@utils'
import { FORM_IP } from '@/config/config'
export default {
  data() {
    return {
      scanUrl1: 'https://wwww.baidu.com',
      isEnvironment: true,
      imgSrce: '',
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {},
      // openId: 'osXvn52SheDzvmvwGdGY8ARq5JAk'
      openId: ''
    }
  },
  mounted() {
    console.log(this.userInfo)
    console.log(getIsWxClient())

    if (getIsWxClient()) {
      // 正式环境
      if (process.env.NODE_ENV !== 'development') {
        const codeKey = getQueryString('code')

        if (codeKey) {
          this.obtainOpenId(codeKey)
        } else {
          wxGrant()
        }
      }
    } else {
      this.isEnvironment = true
    }
    this.qrcode(this.scanUrl1)
  },
  methods: {
    // 通过code获取openId
    obtainOpenId(code) {
      getOpenIdByCode({ code }).then(res => {
        console.log(res.data)
        if (res.data) {
          this.openId = res.data
        } else {
          this.$router.push({ path: '/lishui/scanCode/errorPage' })
        }
      })
    },
    // 生成二维码
    qrcode(code) {
      let FORM_IP // 流程
      if (process.env.NODE_ENV === 'development') {
        // 本地
        FORM_IP = `http://${window.location.hostname}:1402`
      } else if (window.location.href.includes('8824')) {
        // 测试
        FORM_IP = 'http://10.1.1.124:8824'
      } else {
        // 线上
        FORM_IP = 'https://qym.jxj.lishui.gov.cn' // 移动端域名
      }
      const url =
        FORM_IP +
        '/ent.html#/lishui/punchClockRecords?creditCode=' +
        this.userInfo.creditCode +
        '&openId=' +
        this.openId // 线上
      // const url =
      //   FORM_IP +
      //   '/ent.html#/lishui/punchClockRecords?creditCode=91330104MA2KCR091H&openId=osXvn52SheDzvmvwGdGY8ARq5JAk' // 线上
      console.log('路径', url)

      this.qr = new QRCode('qrcode', {
        width: 160, // 二维码宽度，单位像素
        height: 160, // 二维码高度，单位像素
        text: url // 生成二维码的链接
      })
      // 默认使用Canvas生成，并显示到图片
      const qrcodeHtml = document.getElementById('qrcode')
      setTimeout(() => {
        const imgSrc = document.getElementsByTagName('img')[1]
        this.imgSrce = imgSrc.getAttribute('src')
      }, 50)
    },
    // 下载二维码
    downloadImg() {
      // 找到canvas标签
      const myCanvas = document
        .getElementById('qrcode')
        .getElementsByTagName('canvas')
      // 创建一个a标签节点
      const a = document.createElement('a')
      // 设置a标签的href属性（将canvas变成png图片）
      a.href = myCanvas[0]
        .toDataURL('image/png')
        .replace('image/png', 'image/octet-stream')
      // 设置下载文件的名字
      a.download = '二维码.png'
      // 点击
      a.click()
      Toast('保存成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.attendanc-code {
  .enterprise-code {
    margin: 16px 15px 30px;
    color: rgba(51, 51, 51, 100);
    font-size: 14px;
    i {
      display: inline-block;
      width: 20px;
      height: 19px;
      margin-right: 12px;
      background: url('../../../../assets/enterprise/enterpiet.png') no-repeat;
      background-size: 100%;
    }
  }
  .attendanc-conter {
    text-align: center;
    b {
      font-size: 18px;
      font-weight: 550;
    }
    .conter-code {
      width: 160px;
      height: 160px;
      padding: 10px;
      border-radius: 4px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
      margin: 14px auto;
      position: relative;
      .login-code {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -20px;
        margin-left: -20px;
        z-index: 3;
      }
      #qrcode {
        width: 145px;
        height: 145px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -72.5px;
        margin-left: -72.5px;
        display: none;
        // margin: 20px auto;
        > img {
          // position: absolute;
          // top: 0;
          // left: 0;
          width: 145px !important;
          height: 145px !important;
          border: 4px solid red;
        }
      }
      .qrcode-img {
        width: 145px;
        height: 145px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -72.5px;
        margin-left: -72.5px;
        // border: 1px solid red;
      }
    }
    .explain {
      font-size: 15px;
      color: rgba(153, 153, 153, 100);
    }
  }
  .attendac-footer {
    box-sizing: border-box;
    width: 100%;
    min-height: 60px;
    background: #fff;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.05);
    position: fixed;
    bottom: 0;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    align-items: center;
    padding: 10px;
    .confirm {
      width: 100%;
      height: 40px;
      margin-bottom: 10px;
      background-color: rgba(0, 145, 255, 1);
      color: #fff;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .attendanc-wx {
    font-size: 18px;
    margin: 70px auto;
    text-align: center;
  }
}
</style>
